import React, { useState, useEffect } from "react";
import auth from "./auth";
import { MobileNumberPage } from "./MobileNumberPage";
import { useAlert } from "react-alert";
import { useHistory } from "react-router-dom";
import ReactLoading from "react-loading";
import { PinNumberPage } from "./PinNumberPage";
import { AdditionalInputPage } from "./AdditionalInputPage";
import BlueLogo from "../Resources/logo-blue.png";

export const SportingClubRegistration = (props) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [isFirstPage, setIsFirstPage] = useState(true); //first page consist of enter mobile number and pin page
  const [isLoading, setIsLoading] = useState(false);
  const [dob, setDOB] = useState(null);
  const [memberNumber, setMemberNumber] = useState(null);
  const [isPinPage, setIsPinPage] = useState(false);
  const [isDobPage, setIsDobPage] = useState(true); //true = dob, false = memberNumber
  const [pinNumber, setPinNumber] = useState("");
  const [pinFailCounter, setPinFailCounter] = useState(0);
  const [timerCountdown, setTimerCountdown] = useState(null);
  const alert = useAlert();
  const history = useHistory();

  const clubID = props.clubID;
  const screenWidth = window.screen.width;

  useEffect( () => {
    if(pinNumber.length === 6){
      confirmOTP();
    }
  }, [pinNumber])

  function activatePinPage(){
    setIsPinPage(true);
  }

  function errorAlert(){
    alert.show("Your request currently cannot be processed. Please check if the information your provided was correct and try again.", {
        title: "ERROR"
      });
}

  async function generateOTP(ev=null) {
    if(ev){
      ev.preventDefault();
    }

    setIsLoading(true);
    try {
     await auth.generateOTP(mobileNumber, activatePinPage, errorAlert);
    } catch (exception) {
      console.error(exception);
      alert.show(
        "Your request currently cannot be processed. Please try again later",
        {
          title: "An error has occured",
        }
      );
    } finally {
      setIsLoading(false);
      const timer = Date.now() + 300000;
      setTimerCountdown(timer);
    }
  }

  async function confirmOTP(ev=null) {

    if(ev){
      ev.preventDefault();
    }

    setIsLoading(true);
    try {
      const DTO = { mobileNumber, clubID, dob, pinNumber, memberNumber };

      const response = await fetch(
        localStorage.getItem("server") + "sportingClub",
        {
          method: "POST",
          headers: {
            regoID: 4,
          },
          body: JSON.stringify(DTO),
        }
      );

      const data = await response.json();

      if (data.status === 401) {
          if (pinFailCounter >= 2){
            alert.show('You reached the maximum attempt to confirm your verification code. Please try again later or contact us at 9722 9888.', {
              title: "An error has occurred",
              closeCopy: 'Close',
              onClose: () => {history.push('/home')}
            });
          }
          else {
          setPinFailCounter((pinFailCounter) => pinFailCounter + 1);
          alert.show('Your request cannot be processed. Please check whether the verification code you provided was correct and try again.', {
            title: "An error has occurred",
            closeCopy: 'Close',
          });
        }
      }
      else if (data.status === 200 && data.message === 'Success') {
            alert.show("We have added this sporting affiliation to your membership", {
            title: "Thank You",
            closeCopy: 'Close',
            onClose: () => {history.push('/home')}
          });     
        }
      else if  (data.status === 200 && data.message === 'Need DOB') {
          setIsFirstPage(false);
        }
      else if  (data.status === 200 && data.message === 'Need Member Number') {
          setIsFirstPage(false);
          setIsDobPage(false);
        }
        else if  (data.status === 200 && data.message === 'No Member') {
          history.push('/signup', {clubID, mobileNumber});
        }
      else {
        console.log(data);
        alert.show("We are unable to process your request at this time. Please contact us at 9722 9888", {
          title: "An error has occurred",
          closeCopy: 'Close',
          onClose: () => {history.push('/home')}
        });
      }
      
    } catch (exception) {
      console.error(exception);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (clubID) {
      history.push({
        pathname: "/sportingClubRegistration",
        state: {
          clubID: props.clubID,
        },
      });
    }
  }, []);

  return (
    <div className={screenWidth < 450 ? "mini-form mobile-form" : "mini-form"}>
            <img alt="Bankstown Logo" className="oauth-image" src={BlueLogo} />

      <h2>
        <strong>REGISTER</strong>
      </h2>
      <div className="overlay" hidden={!isLoading}>
        <ReactLoading
          className="loading"
          type={"cylon"}
          color={"#61dafb"}
          height={300}
          width={300}
        />
      </div>
      {isFirstPage ? (
        <div>
          {isPinPage ? (
            <PinNumberPage pinNumber={pinNumber} setPinNumber={setPinNumber} timerCountdown={timerCountdown}/>
          ) : (
            <MobileNumberPage mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} generateOTP={generateOTP}/>
          )}
        </div>
      ) : (
        <AdditionalInputPage parameter={isDobPage? "Date of Birth" : "Member Number"} setParameter={isDobPage? setDOB : setMemberNumber} confirmOTP={confirmOTP}/>
      )}
    </div>
  );
};
